<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="priceRanges"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :text="field.text" :value="field.value">
    </ies-form-field>
</template>


<script>
    /**
     * Gets + Sets hotel price range fields using a single select box
     */
    export default {
        name: 'ies-input-price-range',
        props: ['field', 'recordData'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                priceRanges: [
					'Low',
					'Moderate',
					'Expensive',
					'Very Expensive'
				],
                viewValue: this.field.value,
            }
        },
        created:function() {
            this.getPriceRange();
        },
        methods: {
            getPriceRange:function(){
                axios.get('/api/hotel-price-range/' + this.recordData.hotel_key).then((response) => {
					let ranges = response.data.ranges; 
					this.viewValue = Object.keys(ranges).filter(k => ranges[k])[0] || 0;
                });
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>

